function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import crypto from './webcrypto.js';
import { JOSENotSupported } from '../util/errors.js';
import random from './random.js';
export function generateSecret(_x, _x2) {
  return _generateSecret.apply(this, arguments);
}
function _generateSecret() {
  _generateSecret = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(alg, options) {
    var _options$extractable;
    var length, algorithm, keyUsages, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _t = alg;
          _context.n = _t === 'HS256' ? 1 : _t === 'HS384' ? 1 : _t === 'HS512' ? 1 : _t === 'A128CBC-HS256' ? 2 : _t === 'A192CBC-HS384' ? 2 : _t === 'A256CBC-HS512' ? 2 : _t === 'A128KW' ? 3 : _t === 'A192KW' ? 3 : _t === 'A256KW' ? 3 : _t === 'A128GCMKW' ? 4 : _t === 'A192GCMKW' ? 4 : _t === 'A256GCMKW' ? 4 : _t === 'A128GCM' ? 4 : _t === 'A192GCM' ? 4 : _t === 'A256GCM' ? 4 : 5;
          break;
        case 1:
          length = parseInt(alg.slice(-3), 10);
          algorithm = {
            name: 'HMAC',
            hash: "SHA-".concat(length),
            length: length
          };
          keyUsages = ['sign', 'verify'];
          return _context.a(3, 6);
        case 2:
          length = parseInt(alg.slice(-3), 10);
          return _context.a(2, random(new Uint8Array(length >> 3)));
        case 3:
          length = parseInt(alg.slice(1, 4), 10);
          algorithm = {
            name: 'AES-KW',
            length: length
          };
          keyUsages = ['wrapKey', 'unwrapKey'];
          return _context.a(3, 6);
        case 4:
          length = parseInt(alg.slice(1, 4), 10);
          algorithm = {
            name: 'AES-GCM',
            length: length
          };
          keyUsages = ['encrypt', 'decrypt'];
          return _context.a(3, 6);
        case 5:
          throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        case 6:
          return _context.a(2, crypto.subtle.generateKey(algorithm, (_options$extractable = options === null || options === void 0 ? void 0 : options.extractable) !== null && _options$extractable !== void 0 ? _options$extractable : false, keyUsages));
      }
    }, _callee);
  }));
  return _generateSecret.apply(this, arguments);
}
function getModulusLengthOption(options) {
  var _options$modulusLengt;
  var modulusLength = (_options$modulusLengt = options === null || options === void 0 ? void 0 : options.modulusLength) !== null && _options$modulusLengt !== void 0 ? _options$modulusLengt : 2048;
  if (typeof modulusLength !== 'number' || modulusLength < 2048) {
    throw new JOSENotSupported('Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used');
  }
  return modulusLength;
}
export function generateKeyPair(_x3, _x4) {
  return _generateKeyPair.apply(this, arguments);
}
function _generateKeyPair() {
  _generateKeyPair = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(alg, options) {
    var _options$extractable2;
    var algorithm, keyUsages, _options$crv, crv, _options$crv2, _crv, _t2, _t3, _t4;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          _t2 = alg;
          _context2.n = _t2 === 'PS256' ? 1 : _t2 === 'PS384' ? 1 : _t2 === 'PS512' ? 1 : _t2 === 'RS256' ? 2 : _t2 === 'RS384' ? 2 : _t2 === 'RS512' ? 2 : _t2 === 'RSA-OAEP' ? 3 : _t2 === 'RSA-OAEP-256' ? 3 : _t2 === 'RSA-OAEP-384' ? 3 : _t2 === 'RSA-OAEP-512' ? 3 : _t2 === 'ES256' ? 4 : _t2 === 'ES384' ? 5 : _t2 === 'ES512' ? 6 : _t2 === 'Ed25519' ? 7 : _t2 === 'EdDSA' ? 8 : _t2 === 'ECDH-ES' ? 12 : _t2 === 'ECDH-ES+A128KW' ? 12 : _t2 === 'ECDH-ES+A192KW' ? 12 : _t2 === 'ECDH-ES+A256KW' ? 12 : 17;
          break;
        case 1:
          algorithm = {
            name: 'RSA-PSS',
            hash: "SHA-".concat(alg.slice(-3)),
            publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
            modulusLength: getModulusLengthOption(options)
          };
          keyUsages = ['sign', 'verify'];
          return _context2.a(3, 18);
        case 2:
          algorithm = {
            name: 'RSASSA-PKCS1-v1_5',
            hash: "SHA-".concat(alg.slice(-3)),
            publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
            modulusLength: getModulusLengthOption(options)
          };
          keyUsages = ['sign', 'verify'];
          return _context2.a(3, 18);
        case 3:
          algorithm = {
            name: 'RSA-OAEP',
            hash: "SHA-".concat(parseInt(alg.slice(-3), 10) || 1),
            publicExponent: new Uint8Array([0x01, 0x00, 0x01]),
            modulusLength: getModulusLengthOption(options)
          };
          keyUsages = ['decrypt', 'unwrapKey', 'encrypt', 'wrapKey'];
          return _context2.a(3, 18);
        case 4:
          algorithm = {
            name: 'ECDSA',
            namedCurve: 'P-256'
          };
          keyUsages = ['sign', 'verify'];
          return _context2.a(3, 18);
        case 5:
          algorithm = {
            name: 'ECDSA',
            namedCurve: 'P-384'
          };
          keyUsages = ['sign', 'verify'];
          return _context2.a(3, 18);
        case 6:
          algorithm = {
            name: 'ECDSA',
            namedCurve: 'P-521'
          };
          keyUsages = ['sign', 'verify'];
          return _context2.a(3, 18);
        case 7:
          algorithm = {
            name: 'Ed25519'
          };
          keyUsages = ['sign', 'verify'];
          return _context2.a(3, 18);
        case 8:
          keyUsages = ['sign', 'verify'];
          crv = (_options$crv = options === null || options === void 0 ? void 0 : options.crv) !== null && _options$crv !== void 0 ? _options$crv : 'Ed25519';
          _t3 = crv;
          _context2.n = _t3 === 'Ed25519' ? 9 : _t3 === 'Ed448' ? 9 : 10;
          break;
        case 9:
          algorithm = {
            name: crv
          };
          return _context2.a(3, 11);
        case 10:
          throw new JOSENotSupported('Invalid or unsupported crv option provided');
        case 11:
          return _context2.a(3, 18);
        case 12:
          keyUsages = ['deriveKey', 'deriveBits'];
          _crv = (_options$crv2 = options === null || options === void 0 ? void 0 : options.crv) !== null && _options$crv2 !== void 0 ? _options$crv2 : 'P-256';
          _t4 = _crv;
          _context2.n = _t4 === 'P-256' ? 13 : _t4 === 'P-384' ? 13 : _t4 === 'P-521' ? 13 : _t4 === 'X25519' ? 14 : _t4 === 'X448' ? 14 : 15;
          break;
        case 13:
          algorithm = {
            name: 'ECDH',
            namedCurve: _crv
          };
          return _context2.a(3, 16);
        case 14:
          algorithm = {
            name: _crv
          };
          return _context2.a(3, 16);
        case 15:
          throw new JOSENotSupported('Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448');
        case 16:
          return _context2.a(3, 18);
        case 17:
          throw new JOSENotSupported('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
        case 18:
          return _context2.a(2, crypto.subtle.generateKey(algorithm, (_options$extractable2 = options === null || options === void 0 ? void 0 : options.extractable) !== null && _options$extractable2 !== void 0 ? _options$extractable2 : false, keyUsages));
      }
    }, _callee2);
  }));
  return _generateKeyPair.apply(this, arguments);
}